(function() {
  var productTags = window.__productTags || [];
  if (productTags.indexOf('bundle-variant-switch') === -1) return;

  var allImages = window.__productImages || [];
  var lastKeyword = null;

  function switchGallery(keyword) {
    if (!keyword) return;

    var filtered = allImages.filter(function(img) {
      return img.alt && img.alt.toLowerCase().indexOf(keyword.toLowerCase()) !== -1;
    });

    if (filtered.length === 0) return;

    var thumbs = document.querySelectorAll(
      '.slideshow-controls__thumbnail, .dialog-thumbnails-list__thumbnail'
    );

    var clicked = false;
    thumbs.forEach(function(el) {
      if (clicked) return;
      var img = el.querySelector('img');
      if (!img) return;
      var alt = img.alt || '';
      if (alt.toLowerCase().indexOf(keyword.toLowerCase()) !== -1) {
        ['mousedown', 'mouseup', 'click'].forEach(function(evtName) {
          el.dispatchEvent(new MouseEvent(evtName, { bubbles: true, cancelable: true }));
        });
        clicked = true;
      }
    });
  }

  // 监听变体选择，记录关键词
  document.addEventListener('click', function(e) {
    var label = e.target.closest('.variant-option__button-label');
    if (!label) return;
    var input = label.querySelector('input[type="radio"]');
    if (input && input.value) {
      lastKeyword = input.value;
    }
  });

  document.addEventListener('change', function(e) {
    if (e.target && e.target.type === 'radio' &&
        e.target.name && e.target.name.indexOf('option') !== -1) {
      lastKeyword = e.target.value;
    }
  });

  // 在主题完成更新之后再切换图片
  document.addEventListener('variant:update', function() {
    if (lastKeyword) {
      setTimeout(function() {
        switchGallery(lastKeyword);
      }, 50);
    }
  });

})();